export const selectNonCompliances = state => state.nonCompliance.nonCompliances
